import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import { TableWidget } from "csi/table/Widget";
import { C8Node } from "csi/typings";
import QueryResult from "csi/view/_query/Result";
import declare from "dojo/_base/declare";
import RecipeLineItemNumber from "../Recipe/RecipeLineItemNumber";

/** Renderer for IngredientItemContributor's BOMLineItem's "% of Total" (C8FB-3056) */
const IngredientContributorPctOfTotal = declare(RecipeLineItemNumber, {
	/** boolean: true if the Heading to render is for "After Moisture Loss" */
	afterH2OLoss: false,

	/**
	 * @override
	 * Render IngredientItemContributor's BOMLineItem's "% of Total" (C8FB-3056)
	 */
	toValue(ctx: Context, h: Heading) {
		const value = this.getPercentOfTotal(ctx, this.afterH2OLoss);
		return this.formatValue(value, this._getFormat(ctx, h));
	},

	/**
	 * @override
	 */
	_getPercentOfTotalFromParentLevel(ctx: Context, qr: QueryResult, afterH2OLoss: boolean): number {
		const contributor: C8Node = qr.getNode();
		if (!contributor?.BOMLineItemPctOfLevel) {
			return 1;
		}

		let value = contributor.BOMLineItemPctOfLevel;

		const view = ctx.view as TableWidget;
		const nLevel = qr.hl + 1 - view.getMainLevel();
		if (nLevel > 1) {
			// On level-2 or above, the Percent of Total should be multiplication of PctOfLevel of current and all the parent levels
			value = value * this._getPercentOfTotalFromParentLevel(ctx, qr.parentResult, afterH2OLoss);
		}

		return value;
	},

});

export = IngredientContributorPctOfTotal;